export default "__VITE_ASSET__dba01639__"